"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LAWYER_REPRESENTATIVE_ACCOUNT_SETTING = void 0;
const groups_1 = require("../../groups");
const form_1 = require("../../utils/form");
exports.LAWYER_REPRESENTATIVE_ACCOUNT_SETTING = (0, form_1.form)({
    name: "LAWYER_REPRESENTATIVE_ACCOUNT_SETTING",
    title: "Lawyer Representative Information",
    content: [
        groups_1.QuestionGroup["LAWYER_INTAKE_REPRESENTATIVE_NAME"],
        groups_1.QuestionGroup["LAWYER_INTAKE_REPRESENTATIVE_LEGAL"],
        groups_1.QuestionGroup["LAWYER_INTAKE_REPRESENTATIVE_ADDRESS"],
    ],
    id: 34,
});
